import { DatePicker, Typography } from "antd";
import React from "react";
import { EXPIRY_TYPE } from "../requirements/constants";
const { Text } = Typography;

const expiry = ({ expiries, handleChange, selectedRowKeys }) =>
  function (_, record) {
    const isSelected = selectedRowKeys.includes(record._id);
    const isRequirementNonExpiring = record?.expiryType === EXPIRY_TYPE.DOES_NOT_EXPIRE;

    return isRequirementNonExpiring ? (
      <Text>Does not expire</Text>
    ) : (
      <DatePicker
        disabled={!isSelected}
        onChange={handleChange(record._id)}
        value={expiries[record._id]}
      />
    );
  };

export { expiry };
